import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { Downloads } from 'src/models/downloads';


@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})

export class DownloadsComponent implements OnInit {
  downloads?: Downloads[];


  constructor(private matDialog: MatDialog, private apiService: ApiService, private router: Router) { }

  ngOnInit() {
    this.apiService.loadDownloads().subscribe(result => {
      this.downloads = result
    }
    );
  }

  blank(arquivo: string): boolean {
    if (arquivo.endsWith('.pdf')) {
        return false
    } else
    return true

  }


}
